import { render, staticRenderFns } from "./LabourActionsList.vue?vue&type=template&id=77a8e8ad"
import script from "./LabourActionsList.vue?vue&type=script&lang=js"
export * from "./LabourActionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports